<template>
  <div class="relative" data-test-id="fcc-merchants-container">
    <div
      class="px-4 space-y-4 bg-surface-0 dark:bg-surface-900 rounded-lg border border-surface-200 dark:border-surface-700"
    >
      <MerchantsFilters class="sticky top-[3.6rem] z-20 py-4 w-full" />

      <div v-if="filteredMerchants.length === 0 && !isLoading" class="">
        <div class="p-4 w-full flex items-center justify-center">
          No merchants found.
        </div>
      </div>
      <template v-else>
        <MerchantsTable ref="merchantsTableRef" class="" />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useFCCMerchantStore } from '@/stores/fcc'
import MerchantsFilters from '@/components/fcc/merchants/MerchantsFilters.vue'
import MerchantsTable from '@/components/fcc/merchants/MerchantsTable.vue'

const merchantStore = useFCCMerchantStore()
const { filteredMerchants, loading } = storeToRefs(merchantStore)
const isLoading = loading

const merchantsTableRef = ref()
</script>
